// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-panel-manage_manage_slots_settings {
    padding: 2rem;
    background-color: #f5f7fa;
    min-height: 100vh;
    color: #2d2f33;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }
  
  .manage-slots-wrapper_manage_slots_settings {
    max-width: 1200px;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 12px;
    padding: 2.5rem 2rem;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  }
  
  .manage-slots-wrapper_manage_slots_settings h2 {
    font-size: 1.8rem;
    font-weight: 600;
    color: var(--clr-grey-1);
    margin-bottom: 1.8rem;
    text-align: center;
  }
  
  /* Responsive enhancements */
  @media (max-width: 768px) {
    .main-panel-manage_manage_slots_settings {
      padding: 1rem;
    }
  
    .manage-slots-wrapper_manage_slots_settings {
      padding: 1.5rem 1rem;
    }
  
    .manage-slots-wrapper_manage_slots_settings h2 {
      font-size: 1.5rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Configurations/tabs/ManageSlots/ManageSlots.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,4DAA4D;EAC9D;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,0CAA0C;EAC5C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA,4BAA4B;EAC5B;IACE;MACE,aAAa;IACf;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":[".main-panel-manage_manage_slots_settings {\n    padding: 2rem;\n    background-color: #f5f7fa;\n    min-height: 100vh;\n    color: #2d2f33;\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  }\n  \n  .manage-slots-wrapper_manage_slots_settings {\n    max-width: 1200px;\n    margin: 0 auto;\n    background-color: #ffffff;\n    border-radius: 12px;\n    padding: 2.5rem 2rem;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\n  }\n  \n  .manage-slots-wrapper_manage_slots_settings h2 {\n    font-size: 1.8rem;\n    font-weight: 600;\n    color: var(--clr-grey-1);\n    margin-bottom: 1.8rem;\n    text-align: center;\n  }\n  \n  /* Responsive enhancements */\n  @media (max-width: 768px) {\n    .main-panel-manage_manage_slots_settings {\n      padding: 1rem;\n    }\n  \n    .manage-slots-wrapper_manage_slots_settings {\n      padding: 1.5rem 1rem;\n    }\n  \n    .manage-slots-wrapper_manage_slots_settings h2 {\n      font-size: 1.5rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
